const initialState = {
    tdsPermissions:{},
    tdsLists: [],
    tdsStatus: [],
    changedTdsStatus : [],
    loadingTds: false,
    errorsTds: {},
    tds:{},
    errorMessage:{}
}

const  tdsReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_TDS_LIST_PENDING":
        case "ADD_TDS_PENDING":
        case "ADD_TDS_PERTICULAR_PENDING":
        case "UPDATE_TDS_STATUS_PENDING":
        case "DELETE_TDS_PENDING":
        case "UPDATE_TDS_PENDING":
            return { ...state, loadingTds: true };

        case "GET_TDS_LIST_FULFILLED":
            return {
                ...state,
                loadingTds: false,
                tdsLists: action.payload,
                doctorCount: action.count,
                tdsPermissions:action.permissions,
            };

        case "ADD_TDS_FULFILLED":
            return {
                ...state,
                loadingTds: false,
                changedTdsStatus: action.payload,
            };

        case "ADD_TDS_PERTICULAR_FULFILLED":
            return {
                ...state,
                loadingTds: false,
                tds: action.payload,
            };

            case "UPDATE_TDS_FULFILLED":
            return {
                ...state,
                loadingTds: false,
                tds: action.payload,
            };

        case "UPDATE_TDS_STATUS_FULFILLED":
            return {
                ...state,
                loadingTds: false,
                tds: action.payload,
            };

        case "DELETE_TDS_FULFILLED":
            return {
                ...state,
                loadingTds: false,
                changedTdsStatus: action.payload
            };

        case "RESET_DELETE_TDS_STATUS":
            return {
                ...state,
                loadingTds: false,
                changedTdsStatus: [],
                errorsTds:{}
            };

        case "GET_TDS_LIST_REJECTED":
        case "ADD_TDS_REJECTED":
        case "ADD_TDS_PERTICULAR_REJECTED":
        case "UPDATE_TDS_STATUS_REJECTED":
        case "DELETE_TDS_REJECTED":
        case "UPDATE_TDS_REJECTED":
            return {
                ...state,
                loadingTds: false,
                errorsTds: action.payload,
                errorMessage:action.payload
            };

        default:
            return state;
    }
}

export default tdsReducer;